<button
  type="button"
  class="btn btn-standard"
  *ngIf="hasImportPermission()"
  (click)="onOpenImportOrderSchedule()"
  data-id="importOrderSchedule"
  appBlurOnModalClose
>
  <em class="icon-import mr-1"></em>Import
</button>
